import { AxiosHeaders } from "axios";
import { authProvider, cookiesJar, localAsyncStorage } from "../../features/diProviders";
import { NextDaySCCookies } from "../../utils/internalTypes";
import basicAppConfig from "../constants/basicAppConfig";
import getHeaders from "./getHeaders";
const IMPERSONATE_STORAGE_KEY = "impersonate";
const createApiHeadersInterceptor = (options = {}) => {
    const getApplicationId = options.getApplicationId ?? (() => basicAppConfig.applicationId);
    return async (config) => {
        const userToken = authProvider ? await authProvider.getToken() : undefined;
        const guestUserId = authProvider ? authProvider.getGuestUserId() : undefined;
        const country = cookiesJar ? cookiesJar.getCookie(NextDaySCCookies.COUNTRY) : undefined;
        const impersonateToken = typeof localAsyncStorage?.getItem === "function" ? await localAsyncStorage.getItem(IMPERSONATE_STORAGE_KEY) : undefined;
        const defaultHeaders = getHeaders({
            userToken,
            guestUserId,
            country,
            impersonateToken,
            applicationId: getApplicationId(),
        });
        const mergedHeaders = AxiosHeaders.from(config.headers);
        for (const [name, value] of Object.entries(defaultHeaders)) {
            if (!mergedHeaders.has(name)) {
                mergedHeaders.set(name, value);
            }
        }
        config.headers = mergedHeaders;
        return config;
    };
};
export default createApiHeadersInterceptor;
